// Mock data for Nexline Electrical Ltd.

export const companyInfo = {
  name: "Nexline Electrical Ltd.",
  tagline: "Powering Canada's Future",
  phone: "(647) 768-6872",
  email: "musa@nexlineltd.ca",
  coverage: "Canada-Wide Service",
  instagram: "https://www.instagram.com/nexline_electrical/"
};

export const heroContent = {
  headline: "Precision Power. National Reach.",
  subheadline: "Canada's elite residential and commercial electrical contractor. Licensed, insured, and engineered for excellence.",
  ctaPrimary: "Request a Quote",
  ctaSecondary: "Call Now"
};

export const services = {
  residential: [
    {
      id: 1,
      title: "Residential Electrical Services",
      description: "Complete home electrical solutions from wiring to smart home integration.",
      icon: "Home"
    },
    {
      id: 2,
      title: "Panel Upgrades",
      description: "Modern electrical panel installations and upgrades for increased capacity.",
      icon: "Zap"
    },
    {
      id: 3,
      title: "EV Charger Installation",
      description: "Professional Level 2 and Level 3 EV charging station installation.",
      icon: "Battery"
    }
  ],
  commercial: [
    {
      id: 4,
      title: "Commercial Electrical Services",
      description: "Large-scale electrical infrastructure for businesses and industrial facilities.",
      icon: "Building2"
    },
    {
      id: 5,
      title: "Power Distribution",
      description: "High-capacity power distribution systems designed for commercial demands.",
      icon: "Network"
    },
    {
      id: 6,
      title: "Maintenance & Repairs",
      description: "24/7 emergency response and scheduled maintenance programs.",
      icon: "Wrench"
    }
  ]
};

export const trustPoints = [
  {
    id: 1,
    title: "Licensed & Certified",
    description: "Fully licensed master electricians across all Canadian provinces."
  },
  {
    id: 2,
    title: "Fully Insured",
    description: "Comprehensive liability and worker's compensation coverage."
  },
  {
    id: 3,
    title: "Code Compliant",
    description: "All work meets or exceeds Canadian Electrical Code standards."
  },
  {
    id: 4,
    title: "Safety First",
    description: "Zero-compromise safety protocols on every project."
  }
];

export const portfolioImages = [
  {
    id: 1,
    src: "https://customer-assets.emergentagent.com/job_90c26f30-f80c-4d4d-9163-a2eff3f40a52/artifacts/qyeue54w_Gemini_Generated_Image_bj42jzbj42jzbj42.png",
    alt: "Residential lighting installation"
  },
  {
    id: 2,
    src: "https://customer-assets.emergentagent.com/job_90c26f30-f80c-4d4d-9163-a2eff3f40a52/artifacts/bmkrqwtb_Gemini_Generated_Image_bj42jzbj42jzbj42%20%281%29.png",
    alt: "EV Charger installation"
  }
];

// Instagram video posts to embed
export const instagramVideos = [
  {
    id: 1,
    url: "https://www.instagram.com/p/DTn9qF4ieCX/",
    embedUrl: "https://www.instagram.com/p/DTn9qF4ieCX/embed"
  },
  {
    id: 2,
    url: "https://www.instagram.com/p/DOkFINCjBBn/",
    embedUrl: "https://www.instagram.com/p/DOkFINCjBBn/embed"
  },
  {
    id: 3,
    url: "https://www.instagram.com/p/DOM6GBEDA3b/",
    embedUrl: "https://www.instagram.com/p/DOM6GBEDA3b/embed"
  },
  {
    id: 4,
    url: "https://www.instagram.com/p/DNEjoDLJQAt/",
    embedUrl: "https://www.instagram.com/p/DNEjoDLJQAt/embed"
  }
];

// New higher resolution logos
export const logoUrl = "https://customer-assets.emergentagent.com/job_voltage-pros-1/artifacts/q0l0iy4l_Black%20And%20White%20Simple%20Personal%20Business%20Card.png";

export const logoAltUrl = "https://customer-assets.emergentagent.com/job_voltage-pros-1/artifacts/nqn1uig2_Gemini_Generated_Image_6932qd6932qd6932.png";
